// decode("m_NWM0N2ViZjc1MGJiMTAwMDE2ODVhNzVk0") === 5c47ebf750bb10001685a75d
// decode("m_b0IxeHR4VHRtZQ2") === oB1xtxTtme
import atob from 'atob';

const decode = (memberId, isServerSide) => {
  const username = memberId;
  if (username.startsWith('m_')) {
    const equalCounts = +username[username.length - 1];
    let funlidayMemberId = username.substring(2);
    funlidayMemberId = funlidayMemberId.substring(
      0,
      funlidayMemberId.length - 1,
    );
    if (isServerSide) {
      funlidayMemberId = atob(funlidayMemberId + '='.repeat(equalCounts));
    } else {
      funlidayMemberId = window.atob(
        funlidayMemberId + '='.repeat(equalCounts),
      );
    }
    return funlidayMemberId;
  }
  return username;
};

const encode = (memberId, isServerSide) => {
  let username64;

  if (isServerSide) {
    username64 = Buffer.from(memberId).toString('base64');
  } else {
    username64 = window.btoa(memberId);
  }

  let equalCounts = 0;

  for (let i = username64.length - 1; i > username64.length - 4; i--) {
    if (username64[i] === '=') {
      equalCounts++;
    }
  }

  return `m_${username64.replace(/=/g, '') + equalCounts}`;
};

export { decode, encode };
